/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AccountDeletionRouteImport } from './routes/account-deletion'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as DashboardSupervisorRouteRouteImport } from './routes/dashboard/supervisor/route'
import { Route as DashboardHr_adminRouteRouteImport } from './routes/dashboard/hr_admin/route'
import { Route as DashboardEmployeeRouteRouteImport } from './routes/dashboard/employee/route'
import { Route as DashboardAdminRouteRouteImport } from './routes/dashboard/admin/route'
import { Route as DashboardSupervisorIndexRouteImport } from './routes/dashboard/supervisor/index'
import { Route as DashboardHr_adminIndexRouteImport } from './routes/dashboard/hr_admin/index'
import { Route as DashboardEmployeeIndexRouteImport } from './routes/dashboard/employee/index'
import { Route as DashboardAdminIndexRouteImport } from './routes/dashboard/admin/index'
import { Route as DashboardSupervisorTimesheetsIndexRouteImport } from './routes/dashboard/supervisor/timesheets/index'
import { Route as DashboardSupervisorLeavesIndexRouteImport } from './routes/dashboard/supervisor/leaves/index'
import { Route as DashboardSupervisorEmployeesIndexRouteImport } from './routes/dashboard/supervisor/employees/index'
import { Route as DashboardHr_adminTimesheetsIndexRouteImport } from './routes/dashboard/hr_admin/timesheets/index'
import { Route as DashboardHr_adminLeavesIndexRouteImport } from './routes/dashboard/hr_admin/leaves/index'
import { Route as DashboardHr_adminEmployeesIndexRouteImport } from './routes/dashboard/hr_admin/employees/index'
import { Route as DashboardHr_adminClientsIndexRouteImport } from './routes/dashboard/hr_admin/clients/index'
import { Route as DashboardEmployeeUser_profileIndexRouteImport } from './routes/dashboard/employee/user_profile/index'
import { Route as DashboardEmployeeTimesheetsIndexRouteImport } from './routes/dashboard/employee/timesheets/index'
import { Route as DashboardEmployeeLeavesIndexRouteImport } from './routes/dashboard/employee/leaves/index'
import { Route as DashboardEmployeeEmployee_profileIndexRouteImport } from './routes/dashboard/employee/employee_profile/index'
import { Route as DashboardEmployeeCalendarIndexRouteImport } from './routes/dashboard/employee/calendar/index'
import { Route as DashboardAdminUsers_oldIndexRouteImport } from './routes/dashboard/admin/users_old/index'
import { Route as DashboardAdminUsersIndexRouteImport } from './routes/dashboard/admin/users/index'
import { Route as DashboardAdminUser_profileIndexRouteImport } from './routes/dashboard/admin/user_profile/index'
import { Route as DashboardAdminTimesheetsIndexRouteImport } from './routes/dashboard/admin/timesheets/index'
import { Route as DashboardAdminSuper_adminIndexRouteImport } from './routes/dashboard/admin/super_admin/index'
import { Route as DashboardAdminSoa_government_contributionsIndexRouteImport } from './routes/dashboard/admin/soa_government_contributions/index'
import { Route as DashboardAdminRole_permissionsIndexRouteImport } from './routes/dashboard/admin/role_permissions/index'
import { Route as DashboardAdminPermanent_business_settingsIndexRouteImport } from './routes/dashboard/admin/permanent_business_settings/index'
import { Route as DashboardAdminPayrollIndexRouteImport } from './routes/dashboard/admin/payroll/index'
import { Route as DashboardAdminOgCardsIndexRouteImport } from './routes/dashboard/admin/og-cards/index'
import { Route as DashboardAdminLeavesIndexRouteImport } from './routes/dashboard/admin/leaves/index'
import { Route as DashboardAdminInfoIndexRouteImport } from './routes/dashboard/admin/info/index'
import { Route as DashboardAdminGovernment_contributionsIndexRouteImport } from './routes/dashboard/admin/government_contributions/index'
import { Route as DashboardAdminEventsIndexRouteImport } from './routes/dashboard/admin/events/index'
import { Route as DashboardAdminErrorsIndexRouteImport } from './routes/dashboard/admin/errors/index'
import { Route as DashboardAdminEmployeesIndexRouteImport } from './routes/dashboard/admin/employees/index'
import { Route as DashboardAdminClientsIndexRouteImport } from './routes/dashboard/admin/clients/index'
import { Route as DashboardAdminCategoriesIndexRouteImport } from './routes/dashboard/admin/categories/index'
import { Route as DashboardAdminBusiness_settingsIndexRouteImport } from './routes/dashboard/admin/business_settings/index'
import { Route as DashboardAdminBusiness_infoIndexRouteImport } from './routes/dashboard/admin/business_info/index'
import { Route as DashboardAdminAuditLogsIndexRouteImport } from './routes/dashboard/admin/audit-logs/index'
import { Route as DashboardAdminAnnouncementsIndexRouteImport } from './routes/dashboard/admin/announcements/index'
import { Route as DashboardSupervisorTimesheetsTimesheetIdRouteImport } from './routes/dashboard/supervisor/timesheets/$timesheetId'
import { Route as DashboardSupervisorEmployeesEmployeeIdRouteImport } from './routes/dashboard/supervisor/employees/$employeeId'
import { Route as DashboardHr_adminTimesheetsTimesheetIdRouteImport } from './routes/dashboard/hr_admin/timesheets/$timesheetId'
import { Route as DashboardHr_adminEmployeesEmployeeIdRouteImport } from './routes/dashboard/hr_admin/employees/$employeeId'
import { Route as DashboardHr_adminClientsClientIdRouteImport } from './routes/dashboard/hr_admin/clients/$clientId'
import { Route as DashboardAdminTimesheetsTimesheetIdRouteImport } from './routes/dashboard/admin/timesheets/$timesheetId'
import { Route as DashboardAdminSuper_adminSeedIe298RouteImport } from './routes/dashboard/admin/super_admin/seed-ie298'
import { Route as DashboardAdminSuper_adminNotificationsDebugRouteImport } from './routes/dashboard/admin/super_admin/notifications-debug'
import { Route as DashboardAdminSuper_adminClockStatsRouteImport } from './routes/dashboard/admin/super_admin/clock-stats'
import { Route as DashboardAdminRole_permissionsSupervisorRouteImport } from './routes/dashboard/admin/role_permissions/supervisor'
import { Route as DashboardAdminRole_permissionsHrRecruitmentRouteImport } from './routes/dashboard/admin/role_permissions/hr-recruitment'
import { Route as DashboardAdminRole_permissionsHrAdminRouteImport } from './routes/dashboard/admin/role_permissions/hr-admin'
import { Route as DashboardAdminRole_permissionsEmployeeRouteImport } from './routes/dashboard/admin/role_permissions/employee'
import { Route as DashboardAdminRole_permissionsAdminRouteImport } from './routes/dashboard/admin/role_permissions/admin'
import { Route as DashboardAdminPayrollPayrollIdRouteImport } from './routes/dashboard/admin/payroll/$payrollId'
import { Route as DashboardAdminEmployeesStatisticsRouteImport } from './routes/dashboard/admin/employees/statistics'
import { Route as DashboardAdminEmployeesBillingRouteImport } from './routes/dashboard/admin/employees/billing'
import { Route as DashboardAdminEmployeesEmployeeIdRouteImport } from './routes/dashboard/admin/employees/$employeeId'
import { Route as DashboardAdminClientsClientIdRouteImport } from './routes/dashboard/admin/clients/$clientId'
import { Route as DashboardSupervisorLeavesHistoryIndexRouteImport } from './routes/dashboard/supervisor/leaves/history/index'
import { Route as DashboardSupervisorLeavesLeaveRequestIdIndexRouteImport } from './routes/dashboard/supervisor/leaves/$leaveRequestId/index'
import { Route as DashboardSupervisorEmployeesEmployeeIdIndexRouteImport } from './routes/dashboard/supervisor/employees/$employeeId/index'
import { Route as DashboardHr_adminLeavesHistoryIndexRouteImport } from './routes/dashboard/hr_admin/leaves/history/index'
import { Route as DashboardHr_adminLeavesLeaveRequestIdIndexRouteImport } from './routes/dashboard/hr_admin/leaves/$leaveRequestId/index'
import { Route as DashboardHr_adminEmployeesEmployeeIdIndexRouteImport } from './routes/dashboard/hr_admin/employees/$employeeId/index'
import { Route as DashboardAdminSuper_adminUsersIndexRouteImport } from './routes/dashboard/admin/super_admin/users/index'
import { Route as DashboardAdminSuper_adminOrganizationsIndexRouteImport } from './routes/dashboard/admin/super_admin/organizations/index'
import { Route as DashboardAdminSuper_adminLocationSpoofWhitelistIndexRouteImport } from './routes/dashboard/admin/super_admin/location-spoof-whitelist/index'
import { Route as DashboardAdminSuper_adminEmployeesIndexRouteImport } from './routes/dashboard/admin/super_admin/employees/index'
import { Route as DashboardAdminSuper_adminBillingIndexRouteImport } from './routes/dashboard/admin/super_admin/billing/index'
import { Route as DashboardAdminLeavesHistoryIndexRouteImport } from './routes/dashboard/admin/leaves/history/index'
import { Route as DashboardAdminLeavesLeaveRequestIdIndexRouteImport } from './routes/dashboard/admin/leaves/$leaveRequestId/index'
import { Route as DashboardAdminEmployeesEmployeeIdIndexRouteImport } from './routes/dashboard/admin/employees/$employeeId/index'
import { Route as DashboardAdminBusiness_settingsLeave_typesIndexRouteImport } from './routes/dashboard/admin/business_settings/leave_types/index'
import { Route as DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRouteImport } from './routes/dashboard/supervisor/employees/$employeeId/leave_calendar/index'
import { Route as DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRouteImport } from './routes/dashboard/hr_admin/employees/$employeeId/leave_calendar/index'
import { Route as DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRouteImport } from './routes/dashboard/admin/employees/$employeeId/leave_calendar/index'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountDeletionRoute = AccountDeletionRouteImport.update({
  id: '/account-deletion',
  path: '/account-deletion',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSupervisorRouteRoute =
  DashboardSupervisorRouteRouteImport.update({
    id: '/supervisor',
    path: '/supervisor',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardHr_adminRouteRoute = DashboardHr_adminRouteRouteImport.update({
  id: '/hr_admin',
  path: '/hr_admin',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardEmployeeRouteRoute = DashboardEmployeeRouteRouteImport.update({
  id: '/employee',
  path: '/employee',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardAdminRouteRoute = DashboardAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardSupervisorIndexRoute =
  DashboardSupervisorIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSupervisorRouteRoute,
  } as any)
const DashboardHr_adminIndexRoute = DashboardHr_adminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardHr_adminRouteRoute,
} as any)
const DashboardEmployeeIndexRoute = DashboardEmployeeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardEmployeeRouteRoute,
} as any)
const DashboardAdminIndexRoute = DashboardAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardSupervisorTimesheetsIndexRoute =
  DashboardSupervisorTimesheetsIndexRouteImport.update({
    id: '/timesheets/',
    path: '/timesheets/',
    getParentRoute: () => DashboardSupervisorRouteRoute,
  } as any)
const DashboardSupervisorLeavesIndexRoute =
  DashboardSupervisorLeavesIndexRouteImport.update({
    id: '/leaves/',
    path: '/leaves/',
    getParentRoute: () => DashboardSupervisorRouteRoute,
  } as any)
const DashboardSupervisorEmployeesIndexRoute =
  DashboardSupervisorEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => DashboardSupervisorRouteRoute,
  } as any)
const DashboardHr_adminTimesheetsIndexRoute =
  DashboardHr_adminTimesheetsIndexRouteImport.update({
    id: '/timesheets/',
    path: '/timesheets/',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardHr_adminLeavesIndexRoute =
  DashboardHr_adminLeavesIndexRouteImport.update({
    id: '/leaves/',
    path: '/leaves/',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardHr_adminEmployeesIndexRoute =
  DashboardHr_adminEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardHr_adminClientsIndexRoute =
  DashboardHr_adminClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardEmployeeUser_profileIndexRoute =
  DashboardEmployeeUser_profileIndexRouteImport.update({
    id: '/user_profile/',
    path: '/user_profile/',
    getParentRoute: () => DashboardEmployeeRouteRoute,
  } as any)
const DashboardEmployeeTimesheetsIndexRoute =
  DashboardEmployeeTimesheetsIndexRouteImport.update({
    id: '/timesheets/',
    path: '/timesheets/',
    getParentRoute: () => DashboardEmployeeRouteRoute,
  } as any)
const DashboardEmployeeLeavesIndexRoute =
  DashboardEmployeeLeavesIndexRouteImport.update({
    id: '/leaves/',
    path: '/leaves/',
    getParentRoute: () => DashboardEmployeeRouteRoute,
  } as any)
const DashboardEmployeeEmployee_profileIndexRoute =
  DashboardEmployeeEmployee_profileIndexRouteImport.update({
    id: '/employee_profile/',
    path: '/employee_profile/',
    getParentRoute: () => DashboardEmployeeRouteRoute,
  } as any)
const DashboardEmployeeCalendarIndexRoute =
  DashboardEmployeeCalendarIndexRouteImport.update({
    id: '/calendar/',
    path: '/calendar/',
    getParentRoute: () => DashboardEmployeeRouteRoute,
  } as any)
const DashboardAdminUsers_oldIndexRoute =
  DashboardAdminUsers_oldIndexRouteImport.update({
    id: '/users_old/',
    path: '/users_old/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminUsersIndexRoute =
  DashboardAdminUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminUser_profileIndexRoute =
  DashboardAdminUser_profileIndexRouteImport.update({
    id: '/user_profile/',
    path: '/user_profile/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminTimesheetsIndexRoute =
  DashboardAdminTimesheetsIndexRouteImport.update({
    id: '/timesheets/',
    path: '/timesheets/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuper_adminIndexRoute =
  DashboardAdminSuper_adminIndexRouteImport.update({
    id: '/super_admin/',
    path: '/super_admin/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSoa_government_contributionsIndexRoute =
  DashboardAdminSoa_government_contributionsIndexRouteImport.update({
    id: '/soa_government_contributions/',
    path: '/soa_government_contributions/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminRole_permissionsIndexRoute =
  DashboardAdminRole_permissionsIndexRouteImport.update({
    id: '/role_permissions/',
    path: '/role_permissions/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminPermanent_business_settingsIndexRoute =
  DashboardAdminPermanent_business_settingsIndexRouteImport.update({
    id: '/permanent_business_settings/',
    path: '/permanent_business_settings/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminPayrollIndexRoute =
  DashboardAdminPayrollIndexRouteImport.update({
    id: '/payroll/',
    path: '/payroll/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminOgCardsIndexRoute =
  DashboardAdminOgCardsIndexRouteImport.update({
    id: '/og-cards/',
    path: '/og-cards/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminLeavesIndexRoute =
  DashboardAdminLeavesIndexRouteImport.update({
    id: '/leaves/',
    path: '/leaves/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminInfoIndexRoute = DashboardAdminInfoIndexRouteImport.update({
  id: '/info/',
  path: '/info/',
  getParentRoute: () => DashboardAdminRouteRoute,
} as any)
const DashboardAdminGovernment_contributionsIndexRoute =
  DashboardAdminGovernment_contributionsIndexRouteImport.update({
    id: '/government_contributions/',
    path: '/government_contributions/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminEventsIndexRoute =
  DashboardAdminEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminErrorsIndexRoute =
  DashboardAdminErrorsIndexRouteImport.update({
    id: '/errors/',
    path: '/errors/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminEmployeesIndexRoute =
  DashboardAdminEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminClientsIndexRoute =
  DashboardAdminClientsIndexRouteImport.update({
    id: '/clients/',
    path: '/clients/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminCategoriesIndexRoute =
  DashboardAdminCategoriesIndexRouteImport.update({
    id: '/categories/',
    path: '/categories/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminBusiness_settingsIndexRoute =
  DashboardAdminBusiness_settingsIndexRouteImport.update({
    id: '/business_settings/',
    path: '/business_settings/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminBusiness_infoIndexRoute =
  DashboardAdminBusiness_infoIndexRouteImport.update({
    id: '/business_info/',
    path: '/business_info/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminAuditLogsIndexRoute =
  DashboardAdminAuditLogsIndexRouteImport.update({
    id: '/audit-logs/',
    path: '/audit-logs/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminAnnouncementsIndexRoute =
  DashboardAdminAnnouncementsIndexRouteImport.update({
    id: '/announcements/',
    path: '/announcements/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardSupervisorTimesheetsTimesheetIdRoute =
  DashboardSupervisorTimesheetsTimesheetIdRouteImport.update({
    id: '/timesheets/$timesheetId',
    path: '/timesheets/$timesheetId',
    getParentRoute: () => DashboardSupervisorRouteRoute,
  } as any)
const DashboardSupervisorEmployeesEmployeeIdRoute =
  DashboardSupervisorEmployeesEmployeeIdRouteImport.update({
    id: '/employees/$employeeId',
    path: '/employees/$employeeId',
    getParentRoute: () => DashboardSupervisorRouteRoute,
  } as any)
const DashboardHr_adminTimesheetsTimesheetIdRoute =
  DashboardHr_adminTimesheetsTimesheetIdRouteImport.update({
    id: '/timesheets/$timesheetId',
    path: '/timesheets/$timesheetId',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardHr_adminEmployeesEmployeeIdRoute =
  DashboardHr_adminEmployeesEmployeeIdRouteImport.update({
    id: '/employees/$employeeId',
    path: '/employees/$employeeId',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardHr_adminClientsClientIdRoute =
  DashboardHr_adminClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardAdminTimesheetsTimesheetIdRoute =
  DashboardAdminTimesheetsTimesheetIdRouteImport.update({
    id: '/timesheets/$timesheetId',
    path: '/timesheets/$timesheetId',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuper_adminSeedIe298Route =
  DashboardAdminSuper_adminSeedIe298RouteImport.update({
    id: '/super_admin/seed-ie298',
    path: '/super_admin/seed-ie298',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuper_adminNotificationsDebugRoute =
  DashboardAdminSuper_adminNotificationsDebugRouteImport.update({
    id: '/super_admin/notifications-debug',
    path: '/super_admin/notifications-debug',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuper_adminClockStatsRoute =
  DashboardAdminSuper_adminClockStatsRouteImport.update({
    id: '/super_admin/clock-stats',
    path: '/super_admin/clock-stats',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminRole_permissionsSupervisorRoute =
  DashboardAdminRole_permissionsSupervisorRouteImport.update({
    id: '/role_permissions/supervisor',
    path: '/role_permissions/supervisor',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminRole_permissionsHrRecruitmentRoute =
  DashboardAdminRole_permissionsHrRecruitmentRouteImport.update({
    id: '/role_permissions/hr-recruitment',
    path: '/role_permissions/hr-recruitment',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminRole_permissionsHrAdminRoute =
  DashboardAdminRole_permissionsHrAdminRouteImport.update({
    id: '/role_permissions/hr-admin',
    path: '/role_permissions/hr-admin',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminRole_permissionsEmployeeRoute =
  DashboardAdminRole_permissionsEmployeeRouteImport.update({
    id: '/role_permissions/employee',
    path: '/role_permissions/employee',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminRole_permissionsAdminRoute =
  DashboardAdminRole_permissionsAdminRouteImport.update({
    id: '/role_permissions/admin',
    path: '/role_permissions/admin',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminPayrollPayrollIdRoute =
  DashboardAdminPayrollPayrollIdRouteImport.update({
    id: '/payroll/$payrollId',
    path: '/payroll/$payrollId',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminEmployeesStatisticsRoute =
  DashboardAdminEmployeesStatisticsRouteImport.update({
    id: '/employees/statistics',
    path: '/employees/statistics',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminEmployeesBillingRoute =
  DashboardAdminEmployeesBillingRouteImport.update({
    id: '/employees/billing',
    path: '/employees/billing',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminEmployeesEmployeeIdRoute =
  DashboardAdminEmployeesEmployeeIdRouteImport.update({
    id: '/employees/$employeeId',
    path: '/employees/$employeeId',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminClientsClientIdRoute =
  DashboardAdminClientsClientIdRouteImport.update({
    id: '/clients/$clientId',
    path: '/clients/$clientId',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardSupervisorLeavesHistoryIndexRoute =
  DashboardSupervisorLeavesHistoryIndexRouteImport.update({
    id: '/leaves/history/',
    path: '/leaves/history/',
    getParentRoute: () => DashboardSupervisorRouteRoute,
  } as any)
const DashboardSupervisorLeavesLeaveRequestIdIndexRoute =
  DashboardSupervisorLeavesLeaveRequestIdIndexRouteImport.update({
    id: '/leaves/$leaveRequestId/',
    path: '/leaves/$leaveRequestId/',
    getParentRoute: () => DashboardSupervisorRouteRoute,
  } as any)
const DashboardSupervisorEmployeesEmployeeIdIndexRoute =
  DashboardSupervisorEmployeesEmployeeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardSupervisorEmployeesEmployeeIdRoute,
  } as any)
const DashboardHr_adminLeavesHistoryIndexRoute =
  DashboardHr_adminLeavesHistoryIndexRouteImport.update({
    id: '/leaves/history/',
    path: '/leaves/history/',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardHr_adminLeavesLeaveRequestIdIndexRoute =
  DashboardHr_adminLeavesLeaveRequestIdIndexRouteImport.update({
    id: '/leaves/$leaveRequestId/',
    path: '/leaves/$leaveRequestId/',
    getParentRoute: () => DashboardHr_adminRouteRoute,
  } as any)
const DashboardHr_adminEmployeesEmployeeIdIndexRoute =
  DashboardHr_adminEmployeesEmployeeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardHr_adminEmployeesEmployeeIdRoute,
  } as any)
const DashboardAdminSuper_adminUsersIndexRoute =
  DashboardAdminSuper_adminUsersIndexRouteImport.update({
    id: '/super_admin/users/',
    path: '/super_admin/users/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuper_adminOrganizationsIndexRoute =
  DashboardAdminSuper_adminOrganizationsIndexRouteImport.update({
    id: '/super_admin/organizations/',
    path: '/super_admin/organizations/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuper_adminLocationSpoofWhitelistIndexRoute =
  DashboardAdminSuper_adminLocationSpoofWhitelistIndexRouteImport.update({
    id: '/super_admin/location-spoof-whitelist/',
    path: '/super_admin/location-spoof-whitelist/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuper_adminEmployeesIndexRoute =
  DashboardAdminSuper_adminEmployeesIndexRouteImport.update({
    id: '/super_admin/employees/',
    path: '/super_admin/employees/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminSuper_adminBillingIndexRoute =
  DashboardAdminSuper_adminBillingIndexRouteImport.update({
    id: '/super_admin/billing/',
    path: '/super_admin/billing/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminLeavesHistoryIndexRoute =
  DashboardAdminLeavesHistoryIndexRouteImport.update({
    id: '/leaves/history/',
    path: '/leaves/history/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminLeavesLeaveRequestIdIndexRoute =
  DashboardAdminLeavesLeaveRequestIdIndexRouteImport.update({
    id: '/leaves/$leaveRequestId/',
    path: '/leaves/$leaveRequestId/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardAdminEmployeesEmployeeIdIndexRoute =
  DashboardAdminEmployeesEmployeeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardAdminEmployeesEmployeeIdRoute,
  } as any)
const DashboardAdminBusiness_settingsLeave_typesIndexRoute =
  DashboardAdminBusiness_settingsLeave_typesIndexRouteImport.update({
    id: '/business_settings/leave_types/',
    path: '/business_settings/leave_types/',
    getParentRoute: () => DashboardAdminRouteRoute,
  } as any)
const DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRoute =
  DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRouteImport.update({
    id: '/leave_calendar/',
    path: '/leave_calendar/',
    getParentRoute: () => DashboardSupervisorEmployeesEmployeeIdRoute,
  } as any)
const DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRoute =
  DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRouteImport.update({
    id: '/leave_calendar/',
    path: '/leave_calendar/',
    getParentRoute: () => DashboardHr_adminEmployeesEmployeeIdRoute,
  } as any)
const DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRoute =
  DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRouteImport.update({
    id: '/leave_calendar/',
    path: '/leave_calendar/',
    getParentRoute: () => DashboardAdminEmployeesEmployeeIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/account-deletion': typeof AccountDeletionRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/dashboard/admin': typeof DashboardAdminRouteRouteWithChildren
  '/dashboard/employee': typeof DashboardEmployeeRouteRouteWithChildren
  '/dashboard/hr_admin': typeof DashboardHr_adminRouteRouteWithChildren
  '/dashboard/supervisor': typeof DashboardSupervisorRouteRouteWithChildren
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/employee/': typeof DashboardEmployeeIndexRoute
  '/dashboard/hr_admin/': typeof DashboardHr_adminIndexRoute
  '/dashboard/supervisor/': typeof DashboardSupervisorIndexRoute
  '/dashboard/admin/clients/$clientId': typeof DashboardAdminClientsClientIdRoute
  '/dashboard/admin/employees/$employeeId': typeof DashboardAdminEmployeesEmployeeIdRouteWithChildren
  '/dashboard/admin/employees/billing': typeof DashboardAdminEmployeesBillingRoute
  '/dashboard/admin/employees/statistics': typeof DashboardAdminEmployeesStatisticsRoute
  '/dashboard/admin/payroll/$payrollId': typeof DashboardAdminPayrollPayrollIdRoute
  '/dashboard/admin/role_permissions/admin': typeof DashboardAdminRole_permissionsAdminRoute
  '/dashboard/admin/role_permissions/employee': typeof DashboardAdminRole_permissionsEmployeeRoute
  '/dashboard/admin/role_permissions/hr-admin': typeof DashboardAdminRole_permissionsHrAdminRoute
  '/dashboard/admin/role_permissions/hr-recruitment': typeof DashboardAdminRole_permissionsHrRecruitmentRoute
  '/dashboard/admin/role_permissions/supervisor': typeof DashboardAdminRole_permissionsSupervisorRoute
  '/dashboard/admin/super_admin/clock-stats': typeof DashboardAdminSuper_adminClockStatsRoute
  '/dashboard/admin/super_admin/notifications-debug': typeof DashboardAdminSuper_adminNotificationsDebugRoute
  '/dashboard/admin/super_admin/seed-ie298': typeof DashboardAdminSuper_adminSeedIe298Route
  '/dashboard/admin/timesheets/$timesheetId': typeof DashboardAdminTimesheetsTimesheetIdRoute
  '/dashboard/hr_admin/clients/$clientId': typeof DashboardHr_adminClientsClientIdRoute
  '/dashboard/hr_admin/employees/$employeeId': typeof DashboardHr_adminEmployeesEmployeeIdRouteWithChildren
  '/dashboard/hr_admin/timesheets/$timesheetId': typeof DashboardHr_adminTimesheetsTimesheetIdRoute
  '/dashboard/supervisor/employees/$employeeId': typeof DashboardSupervisorEmployeesEmployeeIdRouteWithChildren
  '/dashboard/supervisor/timesheets/$timesheetId': typeof DashboardSupervisorTimesheetsTimesheetIdRoute
  '/dashboard/admin/announcements': typeof DashboardAdminAnnouncementsIndexRoute
  '/dashboard/admin/audit-logs': typeof DashboardAdminAuditLogsIndexRoute
  '/dashboard/admin/business_info': typeof DashboardAdminBusiness_infoIndexRoute
  '/dashboard/admin/business_settings': typeof DashboardAdminBusiness_settingsIndexRoute
  '/dashboard/admin/categories': typeof DashboardAdminCategoriesIndexRoute
  '/dashboard/admin/clients': typeof DashboardAdminClientsIndexRoute
  '/dashboard/admin/employees': typeof DashboardAdminEmployeesIndexRoute
  '/dashboard/admin/errors': typeof DashboardAdminErrorsIndexRoute
  '/dashboard/admin/events': typeof DashboardAdminEventsIndexRoute
  '/dashboard/admin/government_contributions': typeof DashboardAdminGovernment_contributionsIndexRoute
  '/dashboard/admin/info': typeof DashboardAdminInfoIndexRoute
  '/dashboard/admin/leaves': typeof DashboardAdminLeavesIndexRoute
  '/dashboard/admin/og-cards': typeof DashboardAdminOgCardsIndexRoute
  '/dashboard/admin/payroll': typeof DashboardAdminPayrollIndexRoute
  '/dashboard/admin/permanent_business_settings': typeof DashboardAdminPermanent_business_settingsIndexRoute
  '/dashboard/admin/role_permissions': typeof DashboardAdminRole_permissionsIndexRoute
  '/dashboard/admin/soa_government_contributions': typeof DashboardAdminSoa_government_contributionsIndexRoute
  '/dashboard/admin/super_admin': typeof DashboardAdminSuper_adminIndexRoute
  '/dashboard/admin/timesheets': typeof DashboardAdminTimesheetsIndexRoute
  '/dashboard/admin/user_profile': typeof DashboardAdminUser_profileIndexRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersIndexRoute
  '/dashboard/admin/users_old': typeof DashboardAdminUsers_oldIndexRoute
  '/dashboard/employee/calendar': typeof DashboardEmployeeCalendarIndexRoute
  '/dashboard/employee/employee_profile': typeof DashboardEmployeeEmployee_profileIndexRoute
  '/dashboard/employee/leaves': typeof DashboardEmployeeLeavesIndexRoute
  '/dashboard/employee/timesheets': typeof DashboardEmployeeTimesheetsIndexRoute
  '/dashboard/employee/user_profile': typeof DashboardEmployeeUser_profileIndexRoute
  '/dashboard/hr_admin/clients': typeof DashboardHr_adminClientsIndexRoute
  '/dashboard/hr_admin/employees': typeof DashboardHr_adminEmployeesIndexRoute
  '/dashboard/hr_admin/leaves': typeof DashboardHr_adminLeavesIndexRoute
  '/dashboard/hr_admin/timesheets': typeof DashboardHr_adminTimesheetsIndexRoute
  '/dashboard/supervisor/employees': typeof DashboardSupervisorEmployeesIndexRoute
  '/dashboard/supervisor/leaves': typeof DashboardSupervisorLeavesIndexRoute
  '/dashboard/supervisor/timesheets': typeof DashboardSupervisorTimesheetsIndexRoute
  '/dashboard/admin/business_settings/leave_types': typeof DashboardAdminBusiness_settingsLeave_typesIndexRoute
  '/dashboard/admin/employees/$employeeId/': typeof DashboardAdminEmployeesEmployeeIdIndexRoute
  '/dashboard/admin/leaves/$leaveRequestId': typeof DashboardAdminLeavesLeaveRequestIdIndexRoute
  '/dashboard/admin/leaves/history': typeof DashboardAdminLeavesHistoryIndexRoute
  '/dashboard/admin/super_admin/billing': typeof DashboardAdminSuper_adminBillingIndexRoute
  '/dashboard/admin/super_admin/employees': typeof DashboardAdminSuper_adminEmployeesIndexRoute
  '/dashboard/admin/super_admin/location-spoof-whitelist': typeof DashboardAdminSuper_adminLocationSpoofWhitelistIndexRoute
  '/dashboard/admin/super_admin/organizations': typeof DashboardAdminSuper_adminOrganizationsIndexRoute
  '/dashboard/admin/super_admin/users': typeof DashboardAdminSuper_adminUsersIndexRoute
  '/dashboard/hr_admin/employees/$employeeId/': typeof DashboardHr_adminEmployeesEmployeeIdIndexRoute
  '/dashboard/hr_admin/leaves/$leaveRequestId': typeof DashboardHr_adminLeavesLeaveRequestIdIndexRoute
  '/dashboard/hr_admin/leaves/history': typeof DashboardHr_adminLeavesHistoryIndexRoute
  '/dashboard/supervisor/employees/$employeeId/': typeof DashboardSupervisorEmployeesEmployeeIdIndexRoute
  '/dashboard/supervisor/leaves/$leaveRequestId': typeof DashboardSupervisorLeavesLeaveRequestIdIndexRoute
  '/dashboard/supervisor/leaves/history': typeof DashboardSupervisorLeavesHistoryIndexRoute
  '/dashboard/admin/employees/$employeeId/leave_calendar': typeof DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRoute
  '/dashboard/hr_admin/employees/$employeeId/leave_calendar': typeof DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRoute
  '/dashboard/supervisor/employees/$employeeId/leave_calendar': typeof DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-deletion': typeof AccountDeletionRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/admin': typeof DashboardAdminIndexRoute
  '/dashboard/employee': typeof DashboardEmployeeIndexRoute
  '/dashboard/hr_admin': typeof DashboardHr_adminIndexRoute
  '/dashboard/supervisor': typeof DashboardSupervisorIndexRoute
  '/dashboard/admin/clients/$clientId': typeof DashboardAdminClientsClientIdRoute
  '/dashboard/admin/employees/billing': typeof DashboardAdminEmployeesBillingRoute
  '/dashboard/admin/employees/statistics': typeof DashboardAdminEmployeesStatisticsRoute
  '/dashboard/admin/payroll/$payrollId': typeof DashboardAdminPayrollPayrollIdRoute
  '/dashboard/admin/role_permissions/admin': typeof DashboardAdminRole_permissionsAdminRoute
  '/dashboard/admin/role_permissions/employee': typeof DashboardAdminRole_permissionsEmployeeRoute
  '/dashboard/admin/role_permissions/hr-admin': typeof DashboardAdminRole_permissionsHrAdminRoute
  '/dashboard/admin/role_permissions/hr-recruitment': typeof DashboardAdminRole_permissionsHrRecruitmentRoute
  '/dashboard/admin/role_permissions/supervisor': typeof DashboardAdminRole_permissionsSupervisorRoute
  '/dashboard/admin/super_admin/clock-stats': typeof DashboardAdminSuper_adminClockStatsRoute
  '/dashboard/admin/super_admin/notifications-debug': typeof DashboardAdminSuper_adminNotificationsDebugRoute
  '/dashboard/admin/super_admin/seed-ie298': typeof DashboardAdminSuper_adminSeedIe298Route
  '/dashboard/admin/timesheets/$timesheetId': typeof DashboardAdminTimesheetsTimesheetIdRoute
  '/dashboard/hr_admin/clients/$clientId': typeof DashboardHr_adminClientsClientIdRoute
  '/dashboard/hr_admin/timesheets/$timesheetId': typeof DashboardHr_adminTimesheetsTimesheetIdRoute
  '/dashboard/supervisor/timesheets/$timesheetId': typeof DashboardSupervisorTimesheetsTimesheetIdRoute
  '/dashboard/admin/announcements': typeof DashboardAdminAnnouncementsIndexRoute
  '/dashboard/admin/audit-logs': typeof DashboardAdminAuditLogsIndexRoute
  '/dashboard/admin/business_info': typeof DashboardAdminBusiness_infoIndexRoute
  '/dashboard/admin/business_settings': typeof DashboardAdminBusiness_settingsIndexRoute
  '/dashboard/admin/categories': typeof DashboardAdminCategoriesIndexRoute
  '/dashboard/admin/clients': typeof DashboardAdminClientsIndexRoute
  '/dashboard/admin/employees': typeof DashboardAdminEmployeesIndexRoute
  '/dashboard/admin/errors': typeof DashboardAdminErrorsIndexRoute
  '/dashboard/admin/events': typeof DashboardAdminEventsIndexRoute
  '/dashboard/admin/government_contributions': typeof DashboardAdminGovernment_contributionsIndexRoute
  '/dashboard/admin/info': typeof DashboardAdminInfoIndexRoute
  '/dashboard/admin/leaves': typeof DashboardAdminLeavesIndexRoute
  '/dashboard/admin/og-cards': typeof DashboardAdminOgCardsIndexRoute
  '/dashboard/admin/payroll': typeof DashboardAdminPayrollIndexRoute
  '/dashboard/admin/permanent_business_settings': typeof DashboardAdminPermanent_business_settingsIndexRoute
  '/dashboard/admin/role_permissions': typeof DashboardAdminRole_permissionsIndexRoute
  '/dashboard/admin/soa_government_contributions': typeof DashboardAdminSoa_government_contributionsIndexRoute
  '/dashboard/admin/super_admin': typeof DashboardAdminSuper_adminIndexRoute
  '/dashboard/admin/timesheets': typeof DashboardAdminTimesheetsIndexRoute
  '/dashboard/admin/user_profile': typeof DashboardAdminUser_profileIndexRoute
  '/dashboard/admin/users': typeof DashboardAdminUsersIndexRoute
  '/dashboard/admin/users_old': typeof DashboardAdminUsers_oldIndexRoute
  '/dashboard/employee/calendar': typeof DashboardEmployeeCalendarIndexRoute
  '/dashboard/employee/employee_profile': typeof DashboardEmployeeEmployee_profileIndexRoute
  '/dashboard/employee/leaves': typeof DashboardEmployeeLeavesIndexRoute
  '/dashboard/employee/timesheets': typeof DashboardEmployeeTimesheetsIndexRoute
  '/dashboard/employee/user_profile': typeof DashboardEmployeeUser_profileIndexRoute
  '/dashboard/hr_admin/clients': typeof DashboardHr_adminClientsIndexRoute
  '/dashboard/hr_admin/employees': typeof DashboardHr_adminEmployeesIndexRoute
  '/dashboard/hr_admin/leaves': typeof DashboardHr_adminLeavesIndexRoute
  '/dashboard/hr_admin/timesheets': typeof DashboardHr_adminTimesheetsIndexRoute
  '/dashboard/supervisor/employees': typeof DashboardSupervisorEmployeesIndexRoute
  '/dashboard/supervisor/leaves': typeof DashboardSupervisorLeavesIndexRoute
  '/dashboard/supervisor/timesheets': typeof DashboardSupervisorTimesheetsIndexRoute
  '/dashboard/admin/business_settings/leave_types': typeof DashboardAdminBusiness_settingsLeave_typesIndexRoute
  '/dashboard/admin/employees/$employeeId': typeof DashboardAdminEmployeesEmployeeIdIndexRoute
  '/dashboard/admin/leaves/$leaveRequestId': typeof DashboardAdminLeavesLeaveRequestIdIndexRoute
  '/dashboard/admin/leaves/history': typeof DashboardAdminLeavesHistoryIndexRoute
  '/dashboard/admin/super_admin/billing': typeof DashboardAdminSuper_adminBillingIndexRoute
  '/dashboard/admin/super_admin/employees': typeof DashboardAdminSuper_adminEmployeesIndexRoute
  '/dashboard/admin/super_admin/location-spoof-whitelist': typeof DashboardAdminSuper_adminLocationSpoofWhitelistIndexRoute
  '/dashboard/admin/super_admin/organizations': typeof DashboardAdminSuper_adminOrganizationsIndexRoute
  '/dashboard/admin/super_admin/users': typeof DashboardAdminSuper_adminUsersIndexRoute
  '/dashboard/hr_admin/employees/$employeeId': typeof DashboardHr_adminEmployeesEmployeeIdIndexRoute
  '/dashboard/hr_admin/leaves/$leaveRequestId': typeof DashboardHr_adminLeavesLeaveRequestIdIndexRoute
  '/dashboard/hr_admin/leaves/history': typeof DashboardHr_adminLeavesHistoryIndexRoute
  '/dashboard/supervisor/employees/$employeeId': typeof DashboardSupervisorEmployeesEmployeeIdIndexRoute
  '/dashboard/supervisor/leaves/$leaveRequestId': typeof DashboardSupervisorLeavesLeaveRequestIdIndexRoute
  '/dashboard/supervisor/leaves/history': typeof DashboardSupervisorLeavesHistoryIndexRoute
  '/dashboard/admin/employees/$employeeId/leave_calendar': typeof DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRoute
  '/dashboard/hr_admin/employees/$employeeId/leave_calendar': typeof DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRoute
  '/dashboard/supervisor/employees/$employeeId/leave_calendar': typeof DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteRouteWithChildren
  '/account-deletion': typeof AccountDeletionRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/terms': typeof TermsRoute
  '/dashboard/admin': typeof DashboardAdminRouteRouteWithChildren
  '/dashboard/employee': typeof DashboardEmployeeRouteRouteWithChildren
  '/dashboard/hr_admin': typeof DashboardHr_adminRouteRouteWithChildren
  '/dashboard/supervisor': typeof DashboardSupervisorRouteRouteWithChildren
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/admin/': typeof DashboardAdminIndexRoute
  '/dashboard/employee/': typeof DashboardEmployeeIndexRoute
  '/dashboard/hr_admin/': typeof DashboardHr_adminIndexRoute
  '/dashboard/supervisor/': typeof DashboardSupervisorIndexRoute
  '/dashboard/admin/clients/$clientId': typeof DashboardAdminClientsClientIdRoute
  '/dashboard/admin/employees/$employeeId': typeof DashboardAdminEmployeesEmployeeIdRouteWithChildren
  '/dashboard/admin/employees/billing': typeof DashboardAdminEmployeesBillingRoute
  '/dashboard/admin/employees/statistics': typeof DashboardAdminEmployeesStatisticsRoute
  '/dashboard/admin/payroll/$payrollId': typeof DashboardAdminPayrollPayrollIdRoute
  '/dashboard/admin/role_permissions/admin': typeof DashboardAdminRole_permissionsAdminRoute
  '/dashboard/admin/role_permissions/employee': typeof DashboardAdminRole_permissionsEmployeeRoute
  '/dashboard/admin/role_permissions/hr-admin': typeof DashboardAdminRole_permissionsHrAdminRoute
  '/dashboard/admin/role_permissions/hr-recruitment': typeof DashboardAdminRole_permissionsHrRecruitmentRoute
  '/dashboard/admin/role_permissions/supervisor': typeof DashboardAdminRole_permissionsSupervisorRoute
  '/dashboard/admin/super_admin/clock-stats': typeof DashboardAdminSuper_adminClockStatsRoute
  '/dashboard/admin/super_admin/notifications-debug': typeof DashboardAdminSuper_adminNotificationsDebugRoute
  '/dashboard/admin/super_admin/seed-ie298': typeof DashboardAdminSuper_adminSeedIe298Route
  '/dashboard/admin/timesheets/$timesheetId': typeof DashboardAdminTimesheetsTimesheetIdRoute
  '/dashboard/hr_admin/clients/$clientId': typeof DashboardHr_adminClientsClientIdRoute
  '/dashboard/hr_admin/employees/$employeeId': typeof DashboardHr_adminEmployeesEmployeeIdRouteWithChildren
  '/dashboard/hr_admin/timesheets/$timesheetId': typeof DashboardHr_adminTimesheetsTimesheetIdRoute
  '/dashboard/supervisor/employees/$employeeId': typeof DashboardSupervisorEmployeesEmployeeIdRouteWithChildren
  '/dashboard/supervisor/timesheets/$timesheetId': typeof DashboardSupervisorTimesheetsTimesheetIdRoute
  '/dashboard/admin/announcements/': typeof DashboardAdminAnnouncementsIndexRoute
  '/dashboard/admin/audit-logs/': typeof DashboardAdminAuditLogsIndexRoute
  '/dashboard/admin/business_info/': typeof DashboardAdminBusiness_infoIndexRoute
  '/dashboard/admin/business_settings/': typeof DashboardAdminBusiness_settingsIndexRoute
  '/dashboard/admin/categories/': typeof DashboardAdminCategoriesIndexRoute
  '/dashboard/admin/clients/': typeof DashboardAdminClientsIndexRoute
  '/dashboard/admin/employees/': typeof DashboardAdminEmployeesIndexRoute
  '/dashboard/admin/errors/': typeof DashboardAdminErrorsIndexRoute
  '/dashboard/admin/events/': typeof DashboardAdminEventsIndexRoute
  '/dashboard/admin/government_contributions/': typeof DashboardAdminGovernment_contributionsIndexRoute
  '/dashboard/admin/info/': typeof DashboardAdminInfoIndexRoute
  '/dashboard/admin/leaves/': typeof DashboardAdminLeavesIndexRoute
  '/dashboard/admin/og-cards/': typeof DashboardAdminOgCardsIndexRoute
  '/dashboard/admin/payroll/': typeof DashboardAdminPayrollIndexRoute
  '/dashboard/admin/permanent_business_settings/': typeof DashboardAdminPermanent_business_settingsIndexRoute
  '/dashboard/admin/role_permissions/': typeof DashboardAdminRole_permissionsIndexRoute
  '/dashboard/admin/soa_government_contributions/': typeof DashboardAdminSoa_government_contributionsIndexRoute
  '/dashboard/admin/super_admin/': typeof DashboardAdminSuper_adminIndexRoute
  '/dashboard/admin/timesheets/': typeof DashboardAdminTimesheetsIndexRoute
  '/dashboard/admin/user_profile/': typeof DashboardAdminUser_profileIndexRoute
  '/dashboard/admin/users/': typeof DashboardAdminUsersIndexRoute
  '/dashboard/admin/users_old/': typeof DashboardAdminUsers_oldIndexRoute
  '/dashboard/employee/calendar/': typeof DashboardEmployeeCalendarIndexRoute
  '/dashboard/employee/employee_profile/': typeof DashboardEmployeeEmployee_profileIndexRoute
  '/dashboard/employee/leaves/': typeof DashboardEmployeeLeavesIndexRoute
  '/dashboard/employee/timesheets/': typeof DashboardEmployeeTimesheetsIndexRoute
  '/dashboard/employee/user_profile/': typeof DashboardEmployeeUser_profileIndexRoute
  '/dashboard/hr_admin/clients/': typeof DashboardHr_adminClientsIndexRoute
  '/dashboard/hr_admin/employees/': typeof DashboardHr_adminEmployeesIndexRoute
  '/dashboard/hr_admin/leaves/': typeof DashboardHr_adminLeavesIndexRoute
  '/dashboard/hr_admin/timesheets/': typeof DashboardHr_adminTimesheetsIndexRoute
  '/dashboard/supervisor/employees/': typeof DashboardSupervisorEmployeesIndexRoute
  '/dashboard/supervisor/leaves/': typeof DashboardSupervisorLeavesIndexRoute
  '/dashboard/supervisor/timesheets/': typeof DashboardSupervisorTimesheetsIndexRoute
  '/dashboard/admin/business_settings/leave_types/': typeof DashboardAdminBusiness_settingsLeave_typesIndexRoute
  '/dashboard/admin/employees/$employeeId/': typeof DashboardAdminEmployeesEmployeeIdIndexRoute
  '/dashboard/admin/leaves/$leaveRequestId/': typeof DashboardAdminLeavesLeaveRequestIdIndexRoute
  '/dashboard/admin/leaves/history/': typeof DashboardAdminLeavesHistoryIndexRoute
  '/dashboard/admin/super_admin/billing/': typeof DashboardAdminSuper_adminBillingIndexRoute
  '/dashboard/admin/super_admin/employees/': typeof DashboardAdminSuper_adminEmployeesIndexRoute
  '/dashboard/admin/super_admin/location-spoof-whitelist/': typeof DashboardAdminSuper_adminLocationSpoofWhitelistIndexRoute
  '/dashboard/admin/super_admin/organizations/': typeof DashboardAdminSuper_adminOrganizationsIndexRoute
  '/dashboard/admin/super_admin/users/': typeof DashboardAdminSuper_adminUsersIndexRoute
  '/dashboard/hr_admin/employees/$employeeId/': typeof DashboardHr_adminEmployeesEmployeeIdIndexRoute
  '/dashboard/hr_admin/leaves/$leaveRequestId/': typeof DashboardHr_adminLeavesLeaveRequestIdIndexRoute
  '/dashboard/hr_admin/leaves/history/': typeof DashboardHr_adminLeavesHistoryIndexRoute
  '/dashboard/supervisor/employees/$employeeId/': typeof DashboardSupervisorEmployeesEmployeeIdIndexRoute
  '/dashboard/supervisor/leaves/$leaveRequestId/': typeof DashboardSupervisorLeavesLeaveRequestIdIndexRoute
  '/dashboard/supervisor/leaves/history/': typeof DashboardSupervisorLeavesHistoryIndexRoute
  '/dashboard/admin/employees/$employeeId/leave_calendar/': typeof DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRoute
  '/dashboard/hr_admin/employees/$employeeId/leave_calendar/': typeof DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRoute
  '/dashboard/supervisor/employees/$employeeId/leave_calendar/': typeof DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/account-deletion'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/terms'
    | '/dashboard/admin'
    | '/dashboard/employee'
    | '/dashboard/hr_admin'
    | '/dashboard/supervisor'
    | '/dashboard/'
    | '/dashboard/admin/'
    | '/dashboard/employee/'
    | '/dashboard/hr_admin/'
    | '/dashboard/supervisor/'
    | '/dashboard/admin/clients/$clientId'
    | '/dashboard/admin/employees/$employeeId'
    | '/dashboard/admin/employees/billing'
    | '/dashboard/admin/employees/statistics'
    | '/dashboard/admin/payroll/$payrollId'
    | '/dashboard/admin/role_permissions/admin'
    | '/dashboard/admin/role_permissions/employee'
    | '/dashboard/admin/role_permissions/hr-admin'
    | '/dashboard/admin/role_permissions/hr-recruitment'
    | '/dashboard/admin/role_permissions/supervisor'
    | '/dashboard/admin/super_admin/clock-stats'
    | '/dashboard/admin/super_admin/notifications-debug'
    | '/dashboard/admin/super_admin/seed-ie298'
    | '/dashboard/admin/timesheets/$timesheetId'
    | '/dashboard/hr_admin/clients/$clientId'
    | '/dashboard/hr_admin/employees/$employeeId'
    | '/dashboard/hr_admin/timesheets/$timesheetId'
    | '/dashboard/supervisor/employees/$employeeId'
    | '/dashboard/supervisor/timesheets/$timesheetId'
    | '/dashboard/admin/announcements'
    | '/dashboard/admin/audit-logs'
    | '/dashboard/admin/business_info'
    | '/dashboard/admin/business_settings'
    | '/dashboard/admin/categories'
    | '/dashboard/admin/clients'
    | '/dashboard/admin/employees'
    | '/dashboard/admin/errors'
    | '/dashboard/admin/events'
    | '/dashboard/admin/government_contributions'
    | '/dashboard/admin/info'
    | '/dashboard/admin/leaves'
    | '/dashboard/admin/og-cards'
    | '/dashboard/admin/payroll'
    | '/dashboard/admin/permanent_business_settings'
    | '/dashboard/admin/role_permissions'
    | '/dashboard/admin/soa_government_contributions'
    | '/dashboard/admin/super_admin'
    | '/dashboard/admin/timesheets'
    | '/dashboard/admin/user_profile'
    | '/dashboard/admin/users'
    | '/dashboard/admin/users_old'
    | '/dashboard/employee/calendar'
    | '/dashboard/employee/employee_profile'
    | '/dashboard/employee/leaves'
    | '/dashboard/employee/timesheets'
    | '/dashboard/employee/user_profile'
    | '/dashboard/hr_admin/clients'
    | '/dashboard/hr_admin/employees'
    | '/dashboard/hr_admin/leaves'
    | '/dashboard/hr_admin/timesheets'
    | '/dashboard/supervisor/employees'
    | '/dashboard/supervisor/leaves'
    | '/dashboard/supervisor/timesheets'
    | '/dashboard/admin/business_settings/leave_types'
    | '/dashboard/admin/employees/$employeeId/'
    | '/dashboard/admin/leaves/$leaveRequestId'
    | '/dashboard/admin/leaves/history'
    | '/dashboard/admin/super_admin/billing'
    | '/dashboard/admin/super_admin/employees'
    | '/dashboard/admin/super_admin/location-spoof-whitelist'
    | '/dashboard/admin/super_admin/organizations'
    | '/dashboard/admin/super_admin/users'
    | '/dashboard/hr_admin/employees/$employeeId/'
    | '/dashboard/hr_admin/leaves/$leaveRequestId'
    | '/dashboard/hr_admin/leaves/history'
    | '/dashboard/supervisor/employees/$employeeId/'
    | '/dashboard/supervisor/leaves/$leaveRequestId'
    | '/dashboard/supervisor/leaves/history'
    | '/dashboard/admin/employees/$employeeId/leave_calendar'
    | '/dashboard/hr_admin/employees/$employeeId/leave_calendar'
    | '/dashboard/supervisor/employees/$employeeId/leave_calendar'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-deletion'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/terms'
    | '/dashboard'
    | '/dashboard/admin'
    | '/dashboard/employee'
    | '/dashboard/hr_admin'
    | '/dashboard/supervisor'
    | '/dashboard/admin/clients/$clientId'
    | '/dashboard/admin/employees/billing'
    | '/dashboard/admin/employees/statistics'
    | '/dashboard/admin/payroll/$payrollId'
    | '/dashboard/admin/role_permissions/admin'
    | '/dashboard/admin/role_permissions/employee'
    | '/dashboard/admin/role_permissions/hr-admin'
    | '/dashboard/admin/role_permissions/hr-recruitment'
    | '/dashboard/admin/role_permissions/supervisor'
    | '/dashboard/admin/super_admin/clock-stats'
    | '/dashboard/admin/super_admin/notifications-debug'
    | '/dashboard/admin/super_admin/seed-ie298'
    | '/dashboard/admin/timesheets/$timesheetId'
    | '/dashboard/hr_admin/clients/$clientId'
    | '/dashboard/hr_admin/timesheets/$timesheetId'
    | '/dashboard/supervisor/timesheets/$timesheetId'
    | '/dashboard/admin/announcements'
    | '/dashboard/admin/audit-logs'
    | '/dashboard/admin/business_info'
    | '/dashboard/admin/business_settings'
    | '/dashboard/admin/categories'
    | '/dashboard/admin/clients'
    | '/dashboard/admin/employees'
    | '/dashboard/admin/errors'
    | '/dashboard/admin/events'
    | '/dashboard/admin/government_contributions'
    | '/dashboard/admin/info'
    | '/dashboard/admin/leaves'
    | '/dashboard/admin/og-cards'
    | '/dashboard/admin/payroll'
    | '/dashboard/admin/permanent_business_settings'
    | '/dashboard/admin/role_permissions'
    | '/dashboard/admin/soa_government_contributions'
    | '/dashboard/admin/super_admin'
    | '/dashboard/admin/timesheets'
    | '/dashboard/admin/user_profile'
    | '/dashboard/admin/users'
    | '/dashboard/admin/users_old'
    | '/dashboard/employee/calendar'
    | '/dashboard/employee/employee_profile'
    | '/dashboard/employee/leaves'
    | '/dashboard/employee/timesheets'
    | '/dashboard/employee/user_profile'
    | '/dashboard/hr_admin/clients'
    | '/dashboard/hr_admin/employees'
    | '/dashboard/hr_admin/leaves'
    | '/dashboard/hr_admin/timesheets'
    | '/dashboard/supervisor/employees'
    | '/dashboard/supervisor/leaves'
    | '/dashboard/supervisor/timesheets'
    | '/dashboard/admin/business_settings/leave_types'
    | '/dashboard/admin/employees/$employeeId'
    | '/dashboard/admin/leaves/$leaveRequestId'
    | '/dashboard/admin/leaves/history'
    | '/dashboard/admin/super_admin/billing'
    | '/dashboard/admin/super_admin/employees'
    | '/dashboard/admin/super_admin/location-spoof-whitelist'
    | '/dashboard/admin/super_admin/organizations'
    | '/dashboard/admin/super_admin/users'
    | '/dashboard/hr_admin/employees/$employeeId'
    | '/dashboard/hr_admin/leaves/$leaveRequestId'
    | '/dashboard/hr_admin/leaves/history'
    | '/dashboard/supervisor/employees/$employeeId'
    | '/dashboard/supervisor/leaves/$leaveRequestId'
    | '/dashboard/supervisor/leaves/history'
    | '/dashboard/admin/employees/$employeeId/leave_calendar'
    | '/dashboard/hr_admin/employees/$employeeId/leave_calendar'
    | '/dashboard/supervisor/employees/$employeeId/leave_calendar'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/account-deletion'
    | '/login'
    | '/onboarding'
    | '/privacy'
    | '/terms'
    | '/dashboard/admin'
    | '/dashboard/employee'
    | '/dashboard/hr_admin'
    | '/dashboard/supervisor'
    | '/dashboard/'
    | '/dashboard/admin/'
    | '/dashboard/employee/'
    | '/dashboard/hr_admin/'
    | '/dashboard/supervisor/'
    | '/dashboard/admin/clients/$clientId'
    | '/dashboard/admin/employees/$employeeId'
    | '/dashboard/admin/employees/billing'
    | '/dashboard/admin/employees/statistics'
    | '/dashboard/admin/payroll/$payrollId'
    | '/dashboard/admin/role_permissions/admin'
    | '/dashboard/admin/role_permissions/employee'
    | '/dashboard/admin/role_permissions/hr-admin'
    | '/dashboard/admin/role_permissions/hr-recruitment'
    | '/dashboard/admin/role_permissions/supervisor'
    | '/dashboard/admin/super_admin/clock-stats'
    | '/dashboard/admin/super_admin/notifications-debug'
    | '/dashboard/admin/super_admin/seed-ie298'
    | '/dashboard/admin/timesheets/$timesheetId'
    | '/dashboard/hr_admin/clients/$clientId'
    | '/dashboard/hr_admin/employees/$employeeId'
    | '/dashboard/hr_admin/timesheets/$timesheetId'
    | '/dashboard/supervisor/employees/$employeeId'
    | '/dashboard/supervisor/timesheets/$timesheetId'
    | '/dashboard/admin/announcements/'
    | '/dashboard/admin/audit-logs/'
    | '/dashboard/admin/business_info/'
    | '/dashboard/admin/business_settings/'
    | '/dashboard/admin/categories/'
    | '/dashboard/admin/clients/'
    | '/dashboard/admin/employees/'
    | '/dashboard/admin/errors/'
    | '/dashboard/admin/events/'
    | '/dashboard/admin/government_contributions/'
    | '/dashboard/admin/info/'
    | '/dashboard/admin/leaves/'
    | '/dashboard/admin/og-cards/'
    | '/dashboard/admin/payroll/'
    | '/dashboard/admin/permanent_business_settings/'
    | '/dashboard/admin/role_permissions/'
    | '/dashboard/admin/soa_government_contributions/'
    | '/dashboard/admin/super_admin/'
    | '/dashboard/admin/timesheets/'
    | '/dashboard/admin/user_profile/'
    | '/dashboard/admin/users/'
    | '/dashboard/admin/users_old/'
    | '/dashboard/employee/calendar/'
    | '/dashboard/employee/employee_profile/'
    | '/dashboard/employee/leaves/'
    | '/dashboard/employee/timesheets/'
    | '/dashboard/employee/user_profile/'
    | '/dashboard/hr_admin/clients/'
    | '/dashboard/hr_admin/employees/'
    | '/dashboard/hr_admin/leaves/'
    | '/dashboard/hr_admin/timesheets/'
    | '/dashboard/supervisor/employees/'
    | '/dashboard/supervisor/leaves/'
    | '/dashboard/supervisor/timesheets/'
    | '/dashboard/admin/business_settings/leave_types/'
    | '/dashboard/admin/employees/$employeeId/'
    | '/dashboard/admin/leaves/$leaveRequestId/'
    | '/dashboard/admin/leaves/history/'
    | '/dashboard/admin/super_admin/billing/'
    | '/dashboard/admin/super_admin/employees/'
    | '/dashboard/admin/super_admin/location-spoof-whitelist/'
    | '/dashboard/admin/super_admin/organizations/'
    | '/dashboard/admin/super_admin/users/'
    | '/dashboard/hr_admin/employees/$employeeId/'
    | '/dashboard/hr_admin/leaves/$leaveRequestId/'
    | '/dashboard/hr_admin/leaves/history/'
    | '/dashboard/supervisor/employees/$employeeId/'
    | '/dashboard/supervisor/leaves/$leaveRequestId/'
    | '/dashboard/supervisor/leaves/history/'
    | '/dashboard/admin/employees/$employeeId/leave_calendar/'
    | '/dashboard/hr_admin/employees/$employeeId/leave_calendar/'
    | '/dashboard/supervisor/employees/$employeeId/leave_calendar/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  AccountDeletionRoute: typeof AccountDeletionRoute
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-deletion': {
      id: '/account-deletion'
      path: '/account-deletion'
      fullPath: '/account-deletion'
      preLoaderRoute: typeof AccountDeletionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/supervisor': {
      id: '/dashboard/supervisor'
      path: '/supervisor'
      fullPath: '/dashboard/supervisor'
      preLoaderRoute: typeof DashboardSupervisorRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/hr_admin': {
      id: '/dashboard/hr_admin'
      path: '/hr_admin'
      fullPath: '/dashboard/hr_admin'
      preLoaderRoute: typeof DashboardHr_adminRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/employee': {
      id: '/dashboard/employee'
      path: '/employee'
      fullPath: '/dashboard/employee'
      preLoaderRoute: typeof DashboardEmployeeRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/admin': {
      id: '/dashboard/admin'
      path: '/admin'
      fullPath: '/dashboard/admin'
      preLoaderRoute: typeof DashboardAdminRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/dashboard/supervisor/': {
      id: '/dashboard/supervisor/'
      path: '/'
      fullPath: '/dashboard/supervisor/'
      preLoaderRoute: typeof DashboardSupervisorIndexRouteImport
      parentRoute: typeof DashboardSupervisorRouteRoute
    }
    '/dashboard/hr_admin/': {
      id: '/dashboard/hr_admin/'
      path: '/'
      fullPath: '/dashboard/hr_admin/'
      preLoaderRoute: typeof DashboardHr_adminIndexRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/employee/': {
      id: '/dashboard/employee/'
      path: '/'
      fullPath: '/dashboard/employee/'
      preLoaderRoute: typeof DashboardEmployeeIndexRouteImport
      parentRoute: typeof DashboardEmployeeRouteRoute
    }
    '/dashboard/admin/': {
      id: '/dashboard/admin/'
      path: '/'
      fullPath: '/dashboard/admin/'
      preLoaderRoute: typeof DashboardAdminIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/supervisor/timesheets/': {
      id: '/dashboard/supervisor/timesheets/'
      path: '/timesheets'
      fullPath: '/dashboard/supervisor/timesheets'
      preLoaderRoute: typeof DashboardSupervisorTimesheetsIndexRouteImport
      parentRoute: typeof DashboardSupervisorRouteRoute
    }
    '/dashboard/supervisor/leaves/': {
      id: '/dashboard/supervisor/leaves/'
      path: '/leaves'
      fullPath: '/dashboard/supervisor/leaves'
      preLoaderRoute: typeof DashboardSupervisorLeavesIndexRouteImport
      parentRoute: typeof DashboardSupervisorRouteRoute
    }
    '/dashboard/supervisor/employees/': {
      id: '/dashboard/supervisor/employees/'
      path: '/employees'
      fullPath: '/dashboard/supervisor/employees'
      preLoaderRoute: typeof DashboardSupervisorEmployeesIndexRouteImport
      parentRoute: typeof DashboardSupervisorRouteRoute
    }
    '/dashboard/hr_admin/timesheets/': {
      id: '/dashboard/hr_admin/timesheets/'
      path: '/timesheets'
      fullPath: '/dashboard/hr_admin/timesheets'
      preLoaderRoute: typeof DashboardHr_adminTimesheetsIndexRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/hr_admin/leaves/': {
      id: '/dashboard/hr_admin/leaves/'
      path: '/leaves'
      fullPath: '/dashboard/hr_admin/leaves'
      preLoaderRoute: typeof DashboardHr_adminLeavesIndexRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/hr_admin/employees/': {
      id: '/dashboard/hr_admin/employees/'
      path: '/employees'
      fullPath: '/dashboard/hr_admin/employees'
      preLoaderRoute: typeof DashboardHr_adminEmployeesIndexRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/hr_admin/clients/': {
      id: '/dashboard/hr_admin/clients/'
      path: '/clients'
      fullPath: '/dashboard/hr_admin/clients'
      preLoaderRoute: typeof DashboardHr_adminClientsIndexRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/employee/user_profile/': {
      id: '/dashboard/employee/user_profile/'
      path: '/user_profile'
      fullPath: '/dashboard/employee/user_profile'
      preLoaderRoute: typeof DashboardEmployeeUser_profileIndexRouteImport
      parentRoute: typeof DashboardEmployeeRouteRoute
    }
    '/dashboard/employee/timesheets/': {
      id: '/dashboard/employee/timesheets/'
      path: '/timesheets'
      fullPath: '/dashboard/employee/timesheets'
      preLoaderRoute: typeof DashboardEmployeeTimesheetsIndexRouteImport
      parentRoute: typeof DashboardEmployeeRouteRoute
    }
    '/dashboard/employee/leaves/': {
      id: '/dashboard/employee/leaves/'
      path: '/leaves'
      fullPath: '/dashboard/employee/leaves'
      preLoaderRoute: typeof DashboardEmployeeLeavesIndexRouteImport
      parentRoute: typeof DashboardEmployeeRouteRoute
    }
    '/dashboard/employee/employee_profile/': {
      id: '/dashboard/employee/employee_profile/'
      path: '/employee_profile'
      fullPath: '/dashboard/employee/employee_profile'
      preLoaderRoute: typeof DashboardEmployeeEmployee_profileIndexRouteImport
      parentRoute: typeof DashboardEmployeeRouteRoute
    }
    '/dashboard/employee/calendar/': {
      id: '/dashboard/employee/calendar/'
      path: '/calendar'
      fullPath: '/dashboard/employee/calendar'
      preLoaderRoute: typeof DashboardEmployeeCalendarIndexRouteImport
      parentRoute: typeof DashboardEmployeeRouteRoute
    }
    '/dashboard/admin/users_old/': {
      id: '/dashboard/admin/users_old/'
      path: '/users_old'
      fullPath: '/dashboard/admin/users_old'
      preLoaderRoute: typeof DashboardAdminUsers_oldIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/users/': {
      id: '/dashboard/admin/users/'
      path: '/users'
      fullPath: '/dashboard/admin/users'
      preLoaderRoute: typeof DashboardAdminUsersIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/user_profile/': {
      id: '/dashboard/admin/user_profile/'
      path: '/user_profile'
      fullPath: '/dashboard/admin/user_profile'
      preLoaderRoute: typeof DashboardAdminUser_profileIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/timesheets/': {
      id: '/dashboard/admin/timesheets/'
      path: '/timesheets'
      fullPath: '/dashboard/admin/timesheets'
      preLoaderRoute: typeof DashboardAdminTimesheetsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/super_admin/': {
      id: '/dashboard/admin/super_admin/'
      path: '/super_admin'
      fullPath: '/dashboard/admin/super_admin'
      preLoaderRoute: typeof DashboardAdminSuper_adminIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/soa_government_contributions/': {
      id: '/dashboard/admin/soa_government_contributions/'
      path: '/soa_government_contributions'
      fullPath: '/dashboard/admin/soa_government_contributions'
      preLoaderRoute: typeof DashboardAdminSoa_government_contributionsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/role_permissions/': {
      id: '/dashboard/admin/role_permissions/'
      path: '/role_permissions'
      fullPath: '/dashboard/admin/role_permissions'
      preLoaderRoute: typeof DashboardAdminRole_permissionsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/permanent_business_settings/': {
      id: '/dashboard/admin/permanent_business_settings/'
      path: '/permanent_business_settings'
      fullPath: '/dashboard/admin/permanent_business_settings'
      preLoaderRoute: typeof DashboardAdminPermanent_business_settingsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/payroll/': {
      id: '/dashboard/admin/payroll/'
      path: '/payroll'
      fullPath: '/dashboard/admin/payroll'
      preLoaderRoute: typeof DashboardAdminPayrollIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/og-cards/': {
      id: '/dashboard/admin/og-cards/'
      path: '/og-cards'
      fullPath: '/dashboard/admin/og-cards'
      preLoaderRoute: typeof DashboardAdminOgCardsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/leaves/': {
      id: '/dashboard/admin/leaves/'
      path: '/leaves'
      fullPath: '/dashboard/admin/leaves'
      preLoaderRoute: typeof DashboardAdminLeavesIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/info/': {
      id: '/dashboard/admin/info/'
      path: '/info'
      fullPath: '/dashboard/admin/info'
      preLoaderRoute: typeof DashboardAdminInfoIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/government_contributions/': {
      id: '/dashboard/admin/government_contributions/'
      path: '/government_contributions'
      fullPath: '/dashboard/admin/government_contributions'
      preLoaderRoute: typeof DashboardAdminGovernment_contributionsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/events/': {
      id: '/dashboard/admin/events/'
      path: '/events'
      fullPath: '/dashboard/admin/events'
      preLoaderRoute: typeof DashboardAdminEventsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/errors/': {
      id: '/dashboard/admin/errors/'
      path: '/errors'
      fullPath: '/dashboard/admin/errors'
      preLoaderRoute: typeof DashboardAdminErrorsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/employees/': {
      id: '/dashboard/admin/employees/'
      path: '/employees'
      fullPath: '/dashboard/admin/employees'
      preLoaderRoute: typeof DashboardAdminEmployeesIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/clients/': {
      id: '/dashboard/admin/clients/'
      path: '/clients'
      fullPath: '/dashboard/admin/clients'
      preLoaderRoute: typeof DashboardAdminClientsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/categories/': {
      id: '/dashboard/admin/categories/'
      path: '/categories'
      fullPath: '/dashboard/admin/categories'
      preLoaderRoute: typeof DashboardAdminCategoriesIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/business_settings/': {
      id: '/dashboard/admin/business_settings/'
      path: '/business_settings'
      fullPath: '/dashboard/admin/business_settings'
      preLoaderRoute: typeof DashboardAdminBusiness_settingsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/business_info/': {
      id: '/dashboard/admin/business_info/'
      path: '/business_info'
      fullPath: '/dashboard/admin/business_info'
      preLoaderRoute: typeof DashboardAdminBusiness_infoIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/audit-logs/': {
      id: '/dashboard/admin/audit-logs/'
      path: '/audit-logs'
      fullPath: '/dashboard/admin/audit-logs'
      preLoaderRoute: typeof DashboardAdminAuditLogsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/announcements/': {
      id: '/dashboard/admin/announcements/'
      path: '/announcements'
      fullPath: '/dashboard/admin/announcements'
      preLoaderRoute: typeof DashboardAdminAnnouncementsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/supervisor/timesheets/$timesheetId': {
      id: '/dashboard/supervisor/timesheets/$timesheetId'
      path: '/timesheets/$timesheetId'
      fullPath: '/dashboard/supervisor/timesheets/$timesheetId'
      preLoaderRoute: typeof DashboardSupervisorTimesheetsTimesheetIdRouteImport
      parentRoute: typeof DashboardSupervisorRouteRoute
    }
    '/dashboard/supervisor/employees/$employeeId': {
      id: '/dashboard/supervisor/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/dashboard/supervisor/employees/$employeeId'
      preLoaderRoute: typeof DashboardSupervisorEmployeesEmployeeIdRouteImport
      parentRoute: typeof DashboardSupervisorRouteRoute
    }
    '/dashboard/hr_admin/timesheets/$timesheetId': {
      id: '/dashboard/hr_admin/timesheets/$timesheetId'
      path: '/timesheets/$timesheetId'
      fullPath: '/dashboard/hr_admin/timesheets/$timesheetId'
      preLoaderRoute: typeof DashboardHr_adminTimesheetsTimesheetIdRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/hr_admin/employees/$employeeId': {
      id: '/dashboard/hr_admin/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/dashboard/hr_admin/employees/$employeeId'
      preLoaderRoute: typeof DashboardHr_adminEmployeesEmployeeIdRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/hr_admin/clients/$clientId': {
      id: '/dashboard/hr_admin/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/dashboard/hr_admin/clients/$clientId'
      preLoaderRoute: typeof DashboardHr_adminClientsClientIdRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/admin/timesheets/$timesheetId': {
      id: '/dashboard/admin/timesheets/$timesheetId'
      path: '/timesheets/$timesheetId'
      fullPath: '/dashboard/admin/timesheets/$timesheetId'
      preLoaderRoute: typeof DashboardAdminTimesheetsTimesheetIdRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/super_admin/seed-ie298': {
      id: '/dashboard/admin/super_admin/seed-ie298'
      path: '/super_admin/seed-ie298'
      fullPath: '/dashboard/admin/super_admin/seed-ie298'
      preLoaderRoute: typeof DashboardAdminSuper_adminSeedIe298RouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/super_admin/notifications-debug': {
      id: '/dashboard/admin/super_admin/notifications-debug'
      path: '/super_admin/notifications-debug'
      fullPath: '/dashboard/admin/super_admin/notifications-debug'
      preLoaderRoute: typeof DashboardAdminSuper_adminNotificationsDebugRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/super_admin/clock-stats': {
      id: '/dashboard/admin/super_admin/clock-stats'
      path: '/super_admin/clock-stats'
      fullPath: '/dashboard/admin/super_admin/clock-stats'
      preLoaderRoute: typeof DashboardAdminSuper_adminClockStatsRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/role_permissions/supervisor': {
      id: '/dashboard/admin/role_permissions/supervisor'
      path: '/role_permissions/supervisor'
      fullPath: '/dashboard/admin/role_permissions/supervisor'
      preLoaderRoute: typeof DashboardAdminRole_permissionsSupervisorRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/role_permissions/hr-recruitment': {
      id: '/dashboard/admin/role_permissions/hr-recruitment'
      path: '/role_permissions/hr-recruitment'
      fullPath: '/dashboard/admin/role_permissions/hr-recruitment'
      preLoaderRoute: typeof DashboardAdminRole_permissionsHrRecruitmentRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/role_permissions/hr-admin': {
      id: '/dashboard/admin/role_permissions/hr-admin'
      path: '/role_permissions/hr-admin'
      fullPath: '/dashboard/admin/role_permissions/hr-admin'
      preLoaderRoute: typeof DashboardAdminRole_permissionsHrAdminRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/role_permissions/employee': {
      id: '/dashboard/admin/role_permissions/employee'
      path: '/role_permissions/employee'
      fullPath: '/dashboard/admin/role_permissions/employee'
      preLoaderRoute: typeof DashboardAdminRole_permissionsEmployeeRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/role_permissions/admin': {
      id: '/dashboard/admin/role_permissions/admin'
      path: '/role_permissions/admin'
      fullPath: '/dashboard/admin/role_permissions/admin'
      preLoaderRoute: typeof DashboardAdminRole_permissionsAdminRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/payroll/$payrollId': {
      id: '/dashboard/admin/payroll/$payrollId'
      path: '/payroll/$payrollId'
      fullPath: '/dashboard/admin/payroll/$payrollId'
      preLoaderRoute: typeof DashboardAdminPayrollPayrollIdRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/employees/statistics': {
      id: '/dashboard/admin/employees/statistics'
      path: '/employees/statistics'
      fullPath: '/dashboard/admin/employees/statistics'
      preLoaderRoute: typeof DashboardAdminEmployeesStatisticsRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/employees/billing': {
      id: '/dashboard/admin/employees/billing'
      path: '/employees/billing'
      fullPath: '/dashboard/admin/employees/billing'
      preLoaderRoute: typeof DashboardAdminEmployeesBillingRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/employees/$employeeId': {
      id: '/dashboard/admin/employees/$employeeId'
      path: '/employees/$employeeId'
      fullPath: '/dashboard/admin/employees/$employeeId'
      preLoaderRoute: typeof DashboardAdminEmployeesEmployeeIdRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/clients/$clientId': {
      id: '/dashboard/admin/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/dashboard/admin/clients/$clientId'
      preLoaderRoute: typeof DashboardAdminClientsClientIdRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/supervisor/leaves/history/': {
      id: '/dashboard/supervisor/leaves/history/'
      path: '/leaves/history'
      fullPath: '/dashboard/supervisor/leaves/history'
      preLoaderRoute: typeof DashboardSupervisorLeavesHistoryIndexRouteImport
      parentRoute: typeof DashboardSupervisorRouteRoute
    }
    '/dashboard/supervisor/leaves/$leaveRequestId/': {
      id: '/dashboard/supervisor/leaves/$leaveRequestId/'
      path: '/leaves/$leaveRequestId'
      fullPath: '/dashboard/supervisor/leaves/$leaveRequestId'
      preLoaderRoute: typeof DashboardSupervisorLeavesLeaveRequestIdIndexRouteImport
      parentRoute: typeof DashboardSupervisorRouteRoute
    }
    '/dashboard/supervisor/employees/$employeeId/': {
      id: '/dashboard/supervisor/employees/$employeeId/'
      path: '/'
      fullPath: '/dashboard/supervisor/employees/$employeeId/'
      preLoaderRoute: typeof DashboardSupervisorEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof DashboardSupervisorEmployeesEmployeeIdRoute
    }
    '/dashboard/hr_admin/leaves/history/': {
      id: '/dashboard/hr_admin/leaves/history/'
      path: '/leaves/history'
      fullPath: '/dashboard/hr_admin/leaves/history'
      preLoaderRoute: typeof DashboardHr_adminLeavesHistoryIndexRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/hr_admin/leaves/$leaveRequestId/': {
      id: '/dashboard/hr_admin/leaves/$leaveRequestId/'
      path: '/leaves/$leaveRequestId'
      fullPath: '/dashboard/hr_admin/leaves/$leaveRequestId'
      preLoaderRoute: typeof DashboardHr_adminLeavesLeaveRequestIdIndexRouteImport
      parentRoute: typeof DashboardHr_adminRouteRoute
    }
    '/dashboard/hr_admin/employees/$employeeId/': {
      id: '/dashboard/hr_admin/employees/$employeeId/'
      path: '/'
      fullPath: '/dashboard/hr_admin/employees/$employeeId/'
      preLoaderRoute: typeof DashboardHr_adminEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof DashboardHr_adminEmployeesEmployeeIdRoute
    }
    '/dashboard/admin/super_admin/users/': {
      id: '/dashboard/admin/super_admin/users/'
      path: '/super_admin/users'
      fullPath: '/dashboard/admin/super_admin/users'
      preLoaderRoute: typeof DashboardAdminSuper_adminUsersIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/super_admin/organizations/': {
      id: '/dashboard/admin/super_admin/organizations/'
      path: '/super_admin/organizations'
      fullPath: '/dashboard/admin/super_admin/organizations'
      preLoaderRoute: typeof DashboardAdminSuper_adminOrganizationsIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/super_admin/location-spoof-whitelist/': {
      id: '/dashboard/admin/super_admin/location-spoof-whitelist/'
      path: '/super_admin/location-spoof-whitelist'
      fullPath: '/dashboard/admin/super_admin/location-spoof-whitelist'
      preLoaderRoute: typeof DashboardAdminSuper_adminLocationSpoofWhitelistIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/super_admin/employees/': {
      id: '/dashboard/admin/super_admin/employees/'
      path: '/super_admin/employees'
      fullPath: '/dashboard/admin/super_admin/employees'
      preLoaderRoute: typeof DashboardAdminSuper_adminEmployeesIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/super_admin/billing/': {
      id: '/dashboard/admin/super_admin/billing/'
      path: '/super_admin/billing'
      fullPath: '/dashboard/admin/super_admin/billing'
      preLoaderRoute: typeof DashboardAdminSuper_adminBillingIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/leaves/history/': {
      id: '/dashboard/admin/leaves/history/'
      path: '/leaves/history'
      fullPath: '/dashboard/admin/leaves/history'
      preLoaderRoute: typeof DashboardAdminLeavesHistoryIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/leaves/$leaveRequestId/': {
      id: '/dashboard/admin/leaves/$leaveRequestId/'
      path: '/leaves/$leaveRequestId'
      fullPath: '/dashboard/admin/leaves/$leaveRequestId'
      preLoaderRoute: typeof DashboardAdminLeavesLeaveRequestIdIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/admin/employees/$employeeId/': {
      id: '/dashboard/admin/employees/$employeeId/'
      path: '/'
      fullPath: '/dashboard/admin/employees/$employeeId/'
      preLoaderRoute: typeof DashboardAdminEmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof DashboardAdminEmployeesEmployeeIdRoute
    }
    '/dashboard/admin/business_settings/leave_types/': {
      id: '/dashboard/admin/business_settings/leave_types/'
      path: '/business_settings/leave_types'
      fullPath: '/dashboard/admin/business_settings/leave_types'
      preLoaderRoute: typeof DashboardAdminBusiness_settingsLeave_typesIndexRouteImport
      parentRoute: typeof DashboardAdminRouteRoute
    }
    '/dashboard/supervisor/employees/$employeeId/leave_calendar/': {
      id: '/dashboard/supervisor/employees/$employeeId/leave_calendar/'
      path: '/leave_calendar'
      fullPath: '/dashboard/supervisor/employees/$employeeId/leave_calendar'
      preLoaderRoute: typeof DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRouteImport
      parentRoute: typeof DashboardSupervisorEmployeesEmployeeIdRoute
    }
    '/dashboard/hr_admin/employees/$employeeId/leave_calendar/': {
      id: '/dashboard/hr_admin/employees/$employeeId/leave_calendar/'
      path: '/leave_calendar'
      fullPath: '/dashboard/hr_admin/employees/$employeeId/leave_calendar'
      preLoaderRoute: typeof DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRouteImport
      parentRoute: typeof DashboardHr_adminEmployeesEmployeeIdRoute
    }
    '/dashboard/admin/employees/$employeeId/leave_calendar/': {
      id: '/dashboard/admin/employees/$employeeId/leave_calendar/'
      path: '/leave_calendar'
      fullPath: '/dashboard/admin/employees/$employeeId/leave_calendar'
      preLoaderRoute: typeof DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRouteImport
      parentRoute: typeof DashboardAdminEmployeesEmployeeIdRoute
    }
  }
}

interface DashboardAdminEmployeesEmployeeIdRouteChildren {
  DashboardAdminEmployeesEmployeeIdIndexRoute: typeof DashboardAdminEmployeesEmployeeIdIndexRoute
  DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRoute: typeof DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRoute
}

const DashboardAdminEmployeesEmployeeIdRouteChildren: DashboardAdminEmployeesEmployeeIdRouteChildren =
  {
    DashboardAdminEmployeesEmployeeIdIndexRoute:
      DashboardAdminEmployeesEmployeeIdIndexRoute,
    DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRoute:
      DashboardAdminEmployeesEmployeeIdLeave_calendarIndexRoute,
  }

const DashboardAdminEmployeesEmployeeIdRouteWithChildren =
  DashboardAdminEmployeesEmployeeIdRoute._addFileChildren(
    DashboardAdminEmployeesEmployeeIdRouteChildren,
  )

interface DashboardAdminRouteRouteChildren {
  DashboardAdminIndexRoute: typeof DashboardAdminIndexRoute
  DashboardAdminClientsClientIdRoute: typeof DashboardAdminClientsClientIdRoute
  DashboardAdminEmployeesEmployeeIdRoute: typeof DashboardAdminEmployeesEmployeeIdRouteWithChildren
  DashboardAdminEmployeesBillingRoute: typeof DashboardAdminEmployeesBillingRoute
  DashboardAdminEmployeesStatisticsRoute: typeof DashboardAdminEmployeesStatisticsRoute
  DashboardAdminPayrollPayrollIdRoute: typeof DashboardAdminPayrollPayrollIdRoute
  DashboardAdminRole_permissionsAdminRoute: typeof DashboardAdminRole_permissionsAdminRoute
  DashboardAdminRole_permissionsEmployeeRoute: typeof DashboardAdminRole_permissionsEmployeeRoute
  DashboardAdminRole_permissionsHrAdminRoute: typeof DashboardAdminRole_permissionsHrAdminRoute
  DashboardAdminRole_permissionsHrRecruitmentRoute: typeof DashboardAdminRole_permissionsHrRecruitmentRoute
  DashboardAdminRole_permissionsSupervisorRoute: typeof DashboardAdminRole_permissionsSupervisorRoute
  DashboardAdminSuper_adminClockStatsRoute: typeof DashboardAdminSuper_adminClockStatsRoute
  DashboardAdminSuper_adminNotificationsDebugRoute: typeof DashboardAdminSuper_adminNotificationsDebugRoute
  DashboardAdminSuper_adminSeedIe298Route: typeof DashboardAdminSuper_adminSeedIe298Route
  DashboardAdminTimesheetsTimesheetIdRoute: typeof DashboardAdminTimesheetsTimesheetIdRoute
  DashboardAdminAnnouncementsIndexRoute: typeof DashboardAdminAnnouncementsIndexRoute
  DashboardAdminAuditLogsIndexRoute: typeof DashboardAdminAuditLogsIndexRoute
  DashboardAdminBusiness_infoIndexRoute: typeof DashboardAdminBusiness_infoIndexRoute
  DashboardAdminBusiness_settingsIndexRoute: typeof DashboardAdminBusiness_settingsIndexRoute
  DashboardAdminCategoriesIndexRoute: typeof DashboardAdminCategoriesIndexRoute
  DashboardAdminClientsIndexRoute: typeof DashboardAdminClientsIndexRoute
  DashboardAdminEmployeesIndexRoute: typeof DashboardAdminEmployeesIndexRoute
  DashboardAdminErrorsIndexRoute: typeof DashboardAdminErrorsIndexRoute
  DashboardAdminEventsIndexRoute: typeof DashboardAdminEventsIndexRoute
  DashboardAdminGovernment_contributionsIndexRoute: typeof DashboardAdminGovernment_contributionsIndexRoute
  DashboardAdminInfoIndexRoute: typeof DashboardAdminInfoIndexRoute
  DashboardAdminLeavesIndexRoute: typeof DashboardAdminLeavesIndexRoute
  DashboardAdminOgCardsIndexRoute: typeof DashboardAdminOgCardsIndexRoute
  DashboardAdminPayrollIndexRoute: typeof DashboardAdminPayrollIndexRoute
  DashboardAdminPermanent_business_settingsIndexRoute: typeof DashboardAdminPermanent_business_settingsIndexRoute
  DashboardAdminRole_permissionsIndexRoute: typeof DashboardAdminRole_permissionsIndexRoute
  DashboardAdminSoa_government_contributionsIndexRoute: typeof DashboardAdminSoa_government_contributionsIndexRoute
  DashboardAdminSuper_adminIndexRoute: typeof DashboardAdminSuper_adminIndexRoute
  DashboardAdminTimesheetsIndexRoute: typeof DashboardAdminTimesheetsIndexRoute
  DashboardAdminUser_profileIndexRoute: typeof DashboardAdminUser_profileIndexRoute
  DashboardAdminUsersIndexRoute: typeof DashboardAdminUsersIndexRoute
  DashboardAdminUsers_oldIndexRoute: typeof DashboardAdminUsers_oldIndexRoute
  DashboardAdminBusiness_settingsLeave_typesIndexRoute: typeof DashboardAdminBusiness_settingsLeave_typesIndexRoute
  DashboardAdminLeavesLeaveRequestIdIndexRoute: typeof DashboardAdminLeavesLeaveRequestIdIndexRoute
  DashboardAdminLeavesHistoryIndexRoute: typeof DashboardAdminLeavesHistoryIndexRoute
  DashboardAdminSuper_adminBillingIndexRoute: typeof DashboardAdminSuper_adminBillingIndexRoute
  DashboardAdminSuper_adminEmployeesIndexRoute: typeof DashboardAdminSuper_adminEmployeesIndexRoute
  DashboardAdminSuper_adminLocationSpoofWhitelistIndexRoute: typeof DashboardAdminSuper_adminLocationSpoofWhitelistIndexRoute
  DashboardAdminSuper_adminOrganizationsIndexRoute: typeof DashboardAdminSuper_adminOrganizationsIndexRoute
  DashboardAdminSuper_adminUsersIndexRoute: typeof DashboardAdminSuper_adminUsersIndexRoute
}

const DashboardAdminRouteRouteChildren: DashboardAdminRouteRouteChildren = {
  DashboardAdminIndexRoute: DashboardAdminIndexRoute,
  DashboardAdminClientsClientIdRoute: DashboardAdminClientsClientIdRoute,
  DashboardAdminEmployeesEmployeeIdRoute:
    DashboardAdminEmployeesEmployeeIdRouteWithChildren,
  DashboardAdminEmployeesBillingRoute: DashboardAdminEmployeesBillingRoute,
  DashboardAdminEmployeesStatisticsRoute:
    DashboardAdminEmployeesStatisticsRoute,
  DashboardAdminPayrollPayrollIdRoute: DashboardAdminPayrollPayrollIdRoute,
  DashboardAdminRole_permissionsAdminRoute:
    DashboardAdminRole_permissionsAdminRoute,
  DashboardAdminRole_permissionsEmployeeRoute:
    DashboardAdminRole_permissionsEmployeeRoute,
  DashboardAdminRole_permissionsHrAdminRoute:
    DashboardAdminRole_permissionsHrAdminRoute,
  DashboardAdminRole_permissionsHrRecruitmentRoute:
    DashboardAdminRole_permissionsHrRecruitmentRoute,
  DashboardAdminRole_permissionsSupervisorRoute:
    DashboardAdminRole_permissionsSupervisorRoute,
  DashboardAdminSuper_adminClockStatsRoute:
    DashboardAdminSuper_adminClockStatsRoute,
  DashboardAdminSuper_adminNotificationsDebugRoute:
    DashboardAdminSuper_adminNotificationsDebugRoute,
  DashboardAdminSuper_adminSeedIe298Route:
    DashboardAdminSuper_adminSeedIe298Route,
  DashboardAdminTimesheetsTimesheetIdRoute:
    DashboardAdminTimesheetsTimesheetIdRoute,
  DashboardAdminAnnouncementsIndexRoute: DashboardAdminAnnouncementsIndexRoute,
  DashboardAdminAuditLogsIndexRoute: DashboardAdminAuditLogsIndexRoute,
  DashboardAdminBusiness_infoIndexRoute: DashboardAdminBusiness_infoIndexRoute,
  DashboardAdminBusiness_settingsIndexRoute:
    DashboardAdminBusiness_settingsIndexRoute,
  DashboardAdminCategoriesIndexRoute: DashboardAdminCategoriesIndexRoute,
  DashboardAdminClientsIndexRoute: DashboardAdminClientsIndexRoute,
  DashboardAdminEmployeesIndexRoute: DashboardAdminEmployeesIndexRoute,
  DashboardAdminErrorsIndexRoute: DashboardAdminErrorsIndexRoute,
  DashboardAdminEventsIndexRoute: DashboardAdminEventsIndexRoute,
  DashboardAdminGovernment_contributionsIndexRoute:
    DashboardAdminGovernment_contributionsIndexRoute,
  DashboardAdminInfoIndexRoute: DashboardAdminInfoIndexRoute,
  DashboardAdminLeavesIndexRoute: DashboardAdminLeavesIndexRoute,
  DashboardAdminOgCardsIndexRoute: DashboardAdminOgCardsIndexRoute,
  DashboardAdminPayrollIndexRoute: DashboardAdminPayrollIndexRoute,
  DashboardAdminPermanent_business_settingsIndexRoute:
    DashboardAdminPermanent_business_settingsIndexRoute,
  DashboardAdminRole_permissionsIndexRoute:
    DashboardAdminRole_permissionsIndexRoute,
  DashboardAdminSoa_government_contributionsIndexRoute:
    DashboardAdminSoa_government_contributionsIndexRoute,
  DashboardAdminSuper_adminIndexRoute: DashboardAdminSuper_adminIndexRoute,
  DashboardAdminTimesheetsIndexRoute: DashboardAdminTimesheetsIndexRoute,
  DashboardAdminUser_profileIndexRoute: DashboardAdminUser_profileIndexRoute,
  DashboardAdminUsersIndexRoute: DashboardAdminUsersIndexRoute,
  DashboardAdminUsers_oldIndexRoute: DashboardAdminUsers_oldIndexRoute,
  DashboardAdminBusiness_settingsLeave_typesIndexRoute:
    DashboardAdminBusiness_settingsLeave_typesIndexRoute,
  DashboardAdminLeavesLeaveRequestIdIndexRoute:
    DashboardAdminLeavesLeaveRequestIdIndexRoute,
  DashboardAdminLeavesHistoryIndexRoute: DashboardAdminLeavesHistoryIndexRoute,
  DashboardAdminSuper_adminBillingIndexRoute:
    DashboardAdminSuper_adminBillingIndexRoute,
  DashboardAdminSuper_adminEmployeesIndexRoute:
    DashboardAdminSuper_adminEmployeesIndexRoute,
  DashboardAdminSuper_adminLocationSpoofWhitelistIndexRoute:
    DashboardAdminSuper_adminLocationSpoofWhitelistIndexRoute,
  DashboardAdminSuper_adminOrganizationsIndexRoute:
    DashboardAdminSuper_adminOrganizationsIndexRoute,
  DashboardAdminSuper_adminUsersIndexRoute:
    DashboardAdminSuper_adminUsersIndexRoute,
}

const DashboardAdminRouteRouteWithChildren =
  DashboardAdminRouteRoute._addFileChildren(DashboardAdminRouteRouteChildren)

interface DashboardEmployeeRouteRouteChildren {
  DashboardEmployeeIndexRoute: typeof DashboardEmployeeIndexRoute
  DashboardEmployeeCalendarIndexRoute: typeof DashboardEmployeeCalendarIndexRoute
  DashboardEmployeeEmployee_profileIndexRoute: typeof DashboardEmployeeEmployee_profileIndexRoute
  DashboardEmployeeLeavesIndexRoute: typeof DashboardEmployeeLeavesIndexRoute
  DashboardEmployeeTimesheetsIndexRoute: typeof DashboardEmployeeTimesheetsIndexRoute
  DashboardEmployeeUser_profileIndexRoute: typeof DashboardEmployeeUser_profileIndexRoute
}

const DashboardEmployeeRouteRouteChildren: DashboardEmployeeRouteRouteChildren =
  {
    DashboardEmployeeIndexRoute: DashboardEmployeeIndexRoute,
    DashboardEmployeeCalendarIndexRoute: DashboardEmployeeCalendarIndexRoute,
    DashboardEmployeeEmployee_profileIndexRoute:
      DashboardEmployeeEmployee_profileIndexRoute,
    DashboardEmployeeLeavesIndexRoute: DashboardEmployeeLeavesIndexRoute,
    DashboardEmployeeTimesheetsIndexRoute:
      DashboardEmployeeTimesheetsIndexRoute,
    DashboardEmployeeUser_profileIndexRoute:
      DashboardEmployeeUser_profileIndexRoute,
  }

const DashboardEmployeeRouteRouteWithChildren =
  DashboardEmployeeRouteRoute._addFileChildren(
    DashboardEmployeeRouteRouteChildren,
  )

interface DashboardHr_adminEmployeesEmployeeIdRouteChildren {
  DashboardHr_adminEmployeesEmployeeIdIndexRoute: typeof DashboardHr_adminEmployeesEmployeeIdIndexRoute
  DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRoute: typeof DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRoute
}

const DashboardHr_adminEmployeesEmployeeIdRouteChildren: DashboardHr_adminEmployeesEmployeeIdRouteChildren =
  {
    DashboardHr_adminEmployeesEmployeeIdIndexRoute:
      DashboardHr_adminEmployeesEmployeeIdIndexRoute,
    DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRoute:
      DashboardHr_adminEmployeesEmployeeIdLeave_calendarIndexRoute,
  }

const DashboardHr_adminEmployeesEmployeeIdRouteWithChildren =
  DashboardHr_adminEmployeesEmployeeIdRoute._addFileChildren(
    DashboardHr_adminEmployeesEmployeeIdRouteChildren,
  )

interface DashboardHr_adminRouteRouteChildren {
  DashboardHr_adminIndexRoute: typeof DashboardHr_adminIndexRoute
  DashboardHr_adminClientsClientIdRoute: typeof DashboardHr_adminClientsClientIdRoute
  DashboardHr_adminEmployeesEmployeeIdRoute: typeof DashboardHr_adminEmployeesEmployeeIdRouteWithChildren
  DashboardHr_adminTimesheetsTimesheetIdRoute: typeof DashboardHr_adminTimesheetsTimesheetIdRoute
  DashboardHr_adminClientsIndexRoute: typeof DashboardHr_adminClientsIndexRoute
  DashboardHr_adminEmployeesIndexRoute: typeof DashboardHr_adminEmployeesIndexRoute
  DashboardHr_adminLeavesIndexRoute: typeof DashboardHr_adminLeavesIndexRoute
  DashboardHr_adminTimesheetsIndexRoute: typeof DashboardHr_adminTimesheetsIndexRoute
  DashboardHr_adminLeavesLeaveRequestIdIndexRoute: typeof DashboardHr_adminLeavesLeaveRequestIdIndexRoute
  DashboardHr_adminLeavesHistoryIndexRoute: typeof DashboardHr_adminLeavesHistoryIndexRoute
}

const DashboardHr_adminRouteRouteChildren: DashboardHr_adminRouteRouteChildren =
  {
    DashboardHr_adminIndexRoute: DashboardHr_adminIndexRoute,
    DashboardHr_adminClientsClientIdRoute:
      DashboardHr_adminClientsClientIdRoute,
    DashboardHr_adminEmployeesEmployeeIdRoute:
      DashboardHr_adminEmployeesEmployeeIdRouteWithChildren,
    DashboardHr_adminTimesheetsTimesheetIdRoute:
      DashboardHr_adminTimesheetsTimesheetIdRoute,
    DashboardHr_adminClientsIndexRoute: DashboardHr_adminClientsIndexRoute,
    DashboardHr_adminEmployeesIndexRoute: DashboardHr_adminEmployeesIndexRoute,
    DashboardHr_adminLeavesIndexRoute: DashboardHr_adminLeavesIndexRoute,
    DashboardHr_adminTimesheetsIndexRoute:
      DashboardHr_adminTimesheetsIndexRoute,
    DashboardHr_adminLeavesLeaveRequestIdIndexRoute:
      DashboardHr_adminLeavesLeaveRequestIdIndexRoute,
    DashboardHr_adminLeavesHistoryIndexRoute:
      DashboardHr_adminLeavesHistoryIndexRoute,
  }

const DashboardHr_adminRouteRouteWithChildren =
  DashboardHr_adminRouteRoute._addFileChildren(
    DashboardHr_adminRouteRouteChildren,
  )

interface DashboardSupervisorEmployeesEmployeeIdRouteChildren {
  DashboardSupervisorEmployeesEmployeeIdIndexRoute: typeof DashboardSupervisorEmployeesEmployeeIdIndexRoute
  DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRoute: typeof DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRoute
}

const DashboardSupervisorEmployeesEmployeeIdRouteChildren: DashboardSupervisorEmployeesEmployeeIdRouteChildren =
  {
    DashboardSupervisorEmployeesEmployeeIdIndexRoute:
      DashboardSupervisorEmployeesEmployeeIdIndexRoute,
    DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRoute:
      DashboardSupervisorEmployeesEmployeeIdLeave_calendarIndexRoute,
  }

const DashboardSupervisorEmployeesEmployeeIdRouteWithChildren =
  DashboardSupervisorEmployeesEmployeeIdRoute._addFileChildren(
    DashboardSupervisorEmployeesEmployeeIdRouteChildren,
  )

interface DashboardSupervisorRouteRouteChildren {
  DashboardSupervisorIndexRoute: typeof DashboardSupervisorIndexRoute
  DashboardSupervisorEmployeesEmployeeIdRoute: typeof DashboardSupervisorEmployeesEmployeeIdRouteWithChildren
  DashboardSupervisorTimesheetsTimesheetIdRoute: typeof DashboardSupervisorTimesheetsTimesheetIdRoute
  DashboardSupervisorEmployeesIndexRoute: typeof DashboardSupervisorEmployeesIndexRoute
  DashboardSupervisorLeavesIndexRoute: typeof DashboardSupervisorLeavesIndexRoute
  DashboardSupervisorTimesheetsIndexRoute: typeof DashboardSupervisorTimesheetsIndexRoute
  DashboardSupervisorLeavesLeaveRequestIdIndexRoute: typeof DashboardSupervisorLeavesLeaveRequestIdIndexRoute
  DashboardSupervisorLeavesHistoryIndexRoute: typeof DashboardSupervisorLeavesHistoryIndexRoute
}

const DashboardSupervisorRouteRouteChildren: DashboardSupervisorRouteRouteChildren =
  {
    DashboardSupervisorIndexRoute: DashboardSupervisorIndexRoute,
    DashboardSupervisorEmployeesEmployeeIdRoute:
      DashboardSupervisorEmployeesEmployeeIdRouteWithChildren,
    DashboardSupervisorTimesheetsTimesheetIdRoute:
      DashboardSupervisorTimesheetsTimesheetIdRoute,
    DashboardSupervisorEmployeesIndexRoute:
      DashboardSupervisorEmployeesIndexRoute,
    DashboardSupervisorLeavesIndexRoute: DashboardSupervisorLeavesIndexRoute,
    DashboardSupervisorTimesheetsIndexRoute:
      DashboardSupervisorTimesheetsIndexRoute,
    DashboardSupervisorLeavesLeaveRequestIdIndexRoute:
      DashboardSupervisorLeavesLeaveRequestIdIndexRoute,
    DashboardSupervisorLeavesHistoryIndexRoute:
      DashboardSupervisorLeavesHistoryIndexRoute,
  }

const DashboardSupervisorRouteRouteWithChildren =
  DashboardSupervisorRouteRoute._addFileChildren(
    DashboardSupervisorRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardAdminRouteRoute: typeof DashboardAdminRouteRouteWithChildren
  DashboardEmployeeRouteRoute: typeof DashboardEmployeeRouteRouteWithChildren
  DashboardHr_adminRouteRoute: typeof DashboardHr_adminRouteRouteWithChildren
  DashboardSupervisorRouteRoute: typeof DashboardSupervisorRouteRouteWithChildren
  DashboardIndexRoute: typeof DashboardIndexRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardAdminRouteRoute: DashboardAdminRouteRouteWithChildren,
  DashboardEmployeeRouteRoute: DashboardEmployeeRouteRouteWithChildren,
  DashboardHr_adminRouteRoute: DashboardHr_adminRouteRouteWithChildren,
  DashboardSupervisorRouteRoute: DashboardSupervisorRouteRouteWithChildren,
  DashboardIndexRoute: DashboardIndexRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  AccountDeletionRoute: AccountDeletionRoute,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
